import type { DemoShiftControlStore } from './interfaces'

export const actions = {
  setLoading (this: DemoShiftControlStore, payload: DemoShiftControlStore['loading']): void {
    this.loading = payload
  },
  setMetrics (this: DemoShiftControlStore, payload: DemoShiftControlStore['metrics']): void {
    this.metrics = payload
  },
  setFilterReservationType (this: DemoShiftControlStore, payload: DemoShiftControlStore['filterReservationType']): void {
    this.filterReservationType = payload
  },
  setFilterSlotStatus (this: DemoShiftControlStore, payload: DemoShiftControlStore['filterSlotStatus']): void {
    this.filterSlotStatus = payload
  },
  setFilterSortBy (this: DemoShiftControlStore, payload: DemoShiftControlStore['filterSortBy']): void {
    this.filterSortBy = payload
  },
  setFilterFrom (this: DemoShiftControlStore, payload: DemoShiftControlStore['filterFrom']): void {
    this.filterFrom = payload
  },
  setFilterTo (this: DemoShiftControlStore, payload: DemoShiftControlStore['filterTo']): void {
    this.filterTo = payload
  },
  setSlotsPaginatedData (this: DemoShiftControlStore, payload: DemoShiftControlStore['slotsPaginatedData']): void {
    this.slotsPaginatedData = payload
  },
  setWaitingBookings (this: DemoShiftControlStore, payload: DemoShiftControlStore['waitingBookings']): void {
    this.waitingBookings = payload
  },
}
